<template>
  <v-dialog
    v-model="dialog"
    v-bind="cardAttrs"
  >
    <template v-slot:activator="{ on, attrs }">
      <div v-if="!isBtn">
        <v-btn
          v-if="conditional"
          id="open"
          v-bind="buttonAttrs"
          :label="label"
          v-on="on"
        >
          {{ label }}
        </v-btn>
      </div>
      <div>
        <slot
          name="open"
          :attrs="attrs"
          :on="on"
        />
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h3>{{ title }}</h3>
      </v-card-title>
      <v-card-text>
        <slot />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          id="closeBtn"
          outlined
          color="primary"
          @click="closeModal()"
        >
          Cancelar
        </v-btn>
        <v-btn
          id="send"
          class="white--text ml-2"
          color="#2ABD49"
          :disabled="disabled"
          :loading="loading"
          @click.prevent="save()"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';

export default {
  name: 'ModalsRequest',
  mixins: [ServiceMixin],
  props: {
    value: {
      type: [Number, String, Array, Object, Function],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    configSwal: {
      type: Object,
      default() {
        return {};
      },
    },
    cardWidth: {
      type: [String, Number],
      default: '',
    },
    btnAttrs: {
      type: Object,
      default() {
        return {};
      },
    },
    disabledSend: {
      type: Boolean,
      default: false,
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
    requestClass: {
      type: Function,
      default() {
        return (value) => Promise.resolve(value);
      },
    },
    manualClose: {
      type: [Boolean, Function],
      default: null,
    },
    persistLoad: {
      type: Boolean,
      default: false,
    },
    send: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    dialog: false,
    loading: false,
  }),
  computed: {
    cardAttrs() {
      return {
        width: this.cardWidth,
        ...this.$attrs,
      };
    },
    isBtn() {
      return this.$scopedSlots && this.$scopedSlots.open;
    },
    disabled() {
      return this.disabledSend;
    },
    conditional() {
      return this.showBtn;
    },
    buttonAttrs() {
      return {
        id: 'open',
        ...this.btnAttrs,
      };
    },
    proxy() {
      return this.requestClass;
    },
  },
  methods: {
    save() {
      this.handleLoading();
      if (!this.send) {
        this.makeRequest();
      } else {
        this.send(
          ...this.sendProps(),
        );
      }
    },
    sendProps() {
      return [
        () => this.makeRequest(),
        () => {
          this.handleLoading();
          this.closeModal();
        },
        () => this.handleLoading(),
      ];
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.proxy(
          this.value,
        ),
        this.requestCallBack,
        this.configSwal,
      );
    },
    requestCallBack(response, err) {
      if (err) {
        this.$emit(
          'error',
          this.errorEmitCallBack(err),
        );
      }

      if (!this.persistLoad) {
        this.handleLoading();
      }
      if (this.isSuccess(response)) {
        this.$emit(
          'success',
          this.getIfHasData(response),
        );
        if (!this.manualClose) {
          this.dialog = false;
        } else if (typeof this.manualClose === 'function') {
          this.manualClose(
            () => {
              this.closeModal();
            },
          );
        }
      }
    },
    errorEmitCallBack(err) {
      return {
        err,
        handleLoading: () => this.handleLoading(),
        closeModal: () => this.closeModal(),
        save: () => this.save(),
      };
    },
    isSuccess(response) {
      return (response && response.data)
      || (response && (response.status >= 200 && response.status <= 300));
    },
    getIfHasData(response) {
      return response && response.data
        ? response.data
        : true;
    },
    closeModal() {
      this.dialog = false;
    },
    bool(v) {
      return new Boolean(v).valueOf();
    },
  },
};
</script>
